import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src916688651/src/pubgen-app/next-app/app/(authenticated)/[workspace]/client.tsx");
